/* b2goshop · Datos de entrega con el formulario de EasySell
   "Continuar con mi pedido" (panel "Tu pedido" y página /cart) abre el formulario de EasySell
   con lo que ya está en el carrito. openTysloForm(true) = modo carrito: no vuelve a sumar
   el producto de la página. Si la app no está cargada, el botón sigue al pago normal de Shopify. */
(function () {
  document.addEventListener('submit', function (e) {
    var f = e.target && e.target.closest && e.target.closest('[data-go], .b2-carrito__go');
    if (!f || typeof window.openTysloForm !== 'function') return;
    e.preventDefault();
    var x = document.querySelector('#b2-pedido:not([hidden]) [data-close-pedido]');
    if (x) x.click();
    try { window.openTysloForm(true); } catch (err) { f.submit(); }
  });
})();
